import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import Link from 'next/link'
import { NotebookPen } from 'lucide-react'
import { cn } from '@/lib/utils'
import { buttonStyles } from '@/lib/button'

interface EmptyStateProps {
    title: string
    description: ReactNode
    icon?: LucideIcon
    action?: {
        label: string
        href: string
        fullReload?: boolean
    }
    className?: string
}

export const EmptyState: FC<EmptyStateProps> = ({
    title,
    description,
    icon: Icon = NotebookPen,
    action,
    className
}): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center rounded-2xl border border-dashed border-border bg-card/60 px-6 py-16 text-center sm:py-20', className)}>
            <span className='inline-flex size-12 items-center justify-center rounded-full bg-accent text-foreground/70'>
                <Icon className='size-5' aria-hidden='true' />
            </span>

            <h2 className='mt-5 font-heading text-2xl font-medium tracking-tight'>
                {title}
            </h2>

            <p className='mt-2 max-w-md text-[0.95rem] leading-relaxed text-muted-foreground'>
                {description}
            </p>

            {action && !action.fullReload && (
                <Link href={action.href} className={buttonStyles('primary', 'mt-7')}>
                    {action.label}
                </Link>
            )}

            {action && action.fullReload && (
                <a href={action.href} className={buttonStyles('primary', 'mt-7')}>
                    {action.label}
                </a>
            )}
        </div>
    )
}
